function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "bin");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 7.5v15c0 0.825 0.675 1.5 1.5 1.5h13.5c0.825 0 1.5-0.675 1.5-1.5v-15h-16.5zM7.5 21h-1.5v-10.5h1.5v10.5zM10.5 21h-1.5v-10.5h1.5v10.5zM13.5 21h-1.5v-10.5h1.5v10.5zM16.5 21h-1.5v-10.5h1.5v10.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.875 3h-4.875v-1.875c0-0.619-0.506-1.125-1.125-1.125h-5.25c-0.619 0-1.125 0.506-1.125 1.125v1.875h-4.875c-0.619 0-1.125 0.506-1.125 1.125v1.875h19.5v-1.875c0-0.619-0.506-1.125-1.125-1.125zM13.5 3h-4.5v-1.481h4.5v1.481z"
});

var SvgBin = function SvgBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bin.26d72515.svg";
export { ForwardRef as ReactComponent };